import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';
import _ from 'lodash';

const provideFile = delegate => event => {
  const file = event.target.files[0];
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => delegate({ name: file.name, data: reader.result });
};

const FormImageUpload = ({
  input,
  label,
  meta: { touched, error },
  readonly,
  onDelete
}) => {
  const id = _.uniqueId('fileInput');
  return (
    <div>
      <Typography variant="caption">{label}</Typography>
      <div className="columns">
        <input
          id={id}
          style={{ display: 'none' }}
          type="file"
          onChange={provideFile(input.onChange)}
          onBlur={provideFile(input.onBlur)}
          disabled={readonly}
        />
        {input.value && <p>{input.value.name || input.value.fileName}</p>}
        <label className="column" htmlFor={id}>
          <Button size="small" component="span" disabled={readonly}>{input.value ? 'Zmień' : 'Wybierz plik ...'}</Button>          
        </label>
        <span className="column" style={{marginBottom:'.5rem'}}>
          {input.value ? <Button size="small" component="span" disabled={readonly} onClick={() => onDelete && !readonly ? onDelete() : null}>Usuń</Button> : null}
        </span>
      </div>
      {touched && error ? <Typography variant="caption" color="error">{error}</Typography> : null}
    </div>
  );
};

FormImageUpload.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  readonly: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default FormImageUpload;



// WEBPACK FOOTER //
// ./src/components/legacyForm/FormImageUpload.js